import { ZyFootnoteIcon } from '@/components/tiptap-editor/tiptap-icons/zyfootnote-icon';
import { isSelectionDescendantOf } from '@/lib/zy-tiptap-utils';
import type { Editor } from '@tiptap/core';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const zyFootnoteContent = {
    number: '1',
    content: [{ type: 'text', text: 'Footnote reference...' }],
};

export function isFootnoteDisabled(editor: Editor) {
    const isSelectionDescendantOfNode = ['testQuestion'].some(node => isSelectionDescendantOf(editor, node));
    if (isSelectionDescendantOfNode) {
        return false;
    }
    return true;
}

const ZyFootnoteButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyFootnote"
        extensionType="node"
        icon={ZyFootnoteIcon}
        label="Insert zyFootnote"
        isDisabled={editor => !isFootnoteDisabled(editor)}
        command={editor => {
            editor.commands.insertZyFootnote(zyFootnoteContent);
        }}
        ref={ref}
        {...props}
    />
));

ZyFootnoteButton.displayName = 'ZyFootnoteButton';

export default ZyFootnoteButton;
